import { lazy } from "react"

const TradeCore = lazy(() => import("./TradeCore"))

export const Trade = () => {
  return <TradeCore />
}
